import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { BASE_URL } from '../../api/baseURL';
import { axiosBaseQuery } from '../axiosBaseQuery';
import { IAgent } from './interface';
import { PaginatedResponse, Response } from '../genericInterface';

export const agentApi = createApi({
  reducerPath: 'agentApi',
  baseQuery: axiosBaseQuery({
    baseUrl: BASE_URL
  }),
  tagTypes: ['agents'],
  endpoints: (builder) => ({
    addAgent: builder.mutation<Response<IAgent>, FormData>({
      query: (payload) => ({
        url: '/agent/add',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['agents']
    }),
    deleteAgent: builder.mutation<Response<IAgent>, string>({
      query: (payload) => ({
        url: `/agent/delete-agent/${payload}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['agents']
    }),
    fetchAgent: builder.query<PaginatedResponse<IAgent>, string | void>({
      query: (query) => ({
        url: `/agent/fetch-many?${query}`,
        method: 'GET'
      }),
      providesTags: ['agents']
    })
  })
});

export const {
  useAddAgentMutation,
  useFetchAgentQuery,
  useDeleteAgentMutation
} = agentApi;
